import React from 'react'
import EditQuickLink from '../../Components/QuickLinks/EditQuickLink'

const EditQuickLinkPage = () => {
  return (
    <EditQuickLink/>
  )
}

export default EditQuickLinkPage
